import React from 'react';
import type { GrievanceServiceSnapshot } from '../../../services/MasterAdmin/grievanceAdminService';

const formatInr = (n: unknown) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return `₹${v.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

const formatVal = (key: string, value: unknown): string => {
  if (value == null || value === '') return '—';
  if (typeof value === 'string' && value.includes('T') && !Number.isNaN(Date.parse(value))) {
    try {
      return new Date(value).toLocaleString();
    } catch {
      return value;
    }
  }
  const k = key.toLowerCase();
  if (
    k.includes('amount') ||
    k.includes('fare') ||
    k.includes('price') ||
    k.includes('paid') ||
    k === 'totalpayableamount' ||
    k === 'subtotal'
  ) {
    const n = Number(value);
    if (Number.isFinite(n)) return formatInr(n);
  }
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

const labelize = (key: string) =>
  key
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());

type Props = {
  snapshot: GrievanceServiceSnapshot | null;
};

export const GrievanceServiceSnapshotPanel: React.FC<Props> = ({ snapshot }) => {
  if (!snapshot) {
    return (
      <div className="rounded-lg border border-dashed border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-900/40 p-4 text-sm text-gray-600 dark:text-gray-400">
        No linked booking or order record found for this service reference.
      </div>
    );
  }

  const entries = Object.entries(snapshot.summary).filter(
    ([, v]) => v != null && v !== '' && String(v).toLowerCase() !== 'null'
  );

  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40 overflow-hidden">
      <div className="border-b border-gray-200 dark:border-gray-700 px-4 py-2.5 bg-white dark:bg-gray-800">
        <p className="text-sm font-semibold text-gray-900 dark:text-white">{snapshot.label}</p>
        <p className="font-mono text-xs text-gray-500 dark:text-gray-400 mt-0.5">{snapshot.refId}</p>
      </div>
      <dl className="divide-y divide-gray-200/80 dark:divide-gray-700/80">
        {entries.map(([key, value]) => (
          <div
            key={key}
            className="grid grid-cols-1 gap-0.5 px-4 py-2.5 sm:grid-cols-3 sm:gap-3"
          >
            <dt className="text-xs font-medium text-gray-500 dark:text-gray-400">{labelize(key)}</dt>
            <dd className="text-sm text-gray-900 dark:text-white sm:col-span-2 break-words">
              {formatVal(key, value)}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
